import(/* webpackMode: "eager" */ "/home/pshemcio/webhorizon/elektroszaman/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/pshemcio/webhorizon/elektroszaman/src/components/home/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/pshemcio/webhorizon/elektroszaman/src/components/sections/ServicesCarousel.tsx");
